import { PromiseQueue } from '@utils'

export const fortunePaymentsQueue = new PromiseQueue()
